const UPGRADE_CUSTODIAN_STEPS = [
  { stepName: 'select-accounts', label: 'Select Accounts', pageIds: [] },
  { stepName: 'confirm-accounts', label: 'Confirm Accounts', pageIds: [] },
  { stepName: 'client-email', label: 'Client Email', pageIds: [] },
  { stepName: 'review-and-submit', label: 'Review & Submit', pageIds: [] },
] as const;

type UpgradeCustodianStepName = (typeof UPGRADE_CUSTODIAN_STEPS)[number]['stepName'];

function getHouseholdOverviewHref(householdPublicId: string): string {
  return `/advisor/dashboard/client/${householdPublicId}`;
}

function getUpgradeCustodianStepHref(householdPublicId: string, stepName: string, pageId?: string): string {
  const stepHref = `${getHouseholdOverviewHref(householdPublicId)}/upgrade-custodian/${stepName}`;
  return pageId !== undefined ? `${stepHref}/${pageId}` : stepHref;
}

// Post-submit confirmation is its own page route (a sibling of the flow's
// [stepName] catch-all), not a flow step — so it doesn't load the flow's query,
// context, or step machinery.
function getUpgradeCustodianConfirmationHref(householdPublicId: string): string {
  return `${getHouseholdOverviewHref(householdPublicId)}/upgrade-custodian/confirmation`;
}

const ACCOUNTS_PANEL_DEFAULT_PERCENT = 25;
const ACCOUNTS_PANEL_MAX_PERCENT = 50;

export type { UpgradeCustodianStepName };
export {
  ACCOUNTS_PANEL_DEFAULT_PERCENT,
  ACCOUNTS_PANEL_MAX_PERCENT,
  UPGRADE_CUSTODIAN_STEPS,
  getHouseholdOverviewHref,
  getUpgradeCustodianConfirmationHref,
  getUpgradeCustodianStepHref,
};
